<template>
<v-card class="result ma-1" :ripple="false" @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title class="pb-1">
        <span>
            <span>{{item.name}}</span>
            <span class="overline font-weight-medium text-center px-1">({{item.id}})</span>
        </span>
        <v-icon class="pa-1 icon-editv3" size="24" color="#5A8DEE" v-show="hover" @click="emitClick()">edit</v-icon>
    </v-card-title>
    <v-card-text class="pa-3">
        <v-row no-gutters>
            <v-col cols="12" md="4" class="px-1 text-truncate">
                {{ $t('cancellation_policies.table_header.penalty') }}:
            </v-col>
            <v-col cols="12" md="8" class="px-1">
                <div v-if="!item.refundable" class="important">
                    Nerambursabil
                </div>
                <div v-else-if="item.rules">
                    <div class="important" v-for="(rule, index) in item.rules" :key="index">
                        <span v-if="rule.interval_type == 'days-until-check-in'">{{ rule.interval_value }} {{ $tc('cancellation_policy.card.interval_days', rule.interval_value) }}</span>
                        <span v-else>{{ $t('cancellation_policy.card.interval_hour') }} {{ rule.interval_value }}</span>
                        -
                        {{ rule.penalty_value }}
                        <span v-if="rule.penalty_type == 'percent'">% total</span>
                        <span v-if="rule.penalty_type == 'fixed'">{{ currency }}</span>
                        <span v-if="rule.penalty_type == 'first-night-percent'">{{ $t('cancellation_policy.card.penalty_value_first_night_percent') }}</span>
                    </div>
                </div>
                <div v-else class="important">
                    Complet rambursabil
                </div>
            </v-col>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    name: `Policy`,
    props: {
        item: Object,
        currency: String
    },

    data() {
        return {
            hover: false,
        };
    },


    methods: {
        emitClick() {
            this.$emit('click');
        },
    },
}
</script>
